import type { Tagged } from "@-/com.npmjs.type-fest";
import { createGate } from "@-/dev.improve.haniverse.lib.gate";

type MnemonicsTab = { name: string; pinyin: string | undefined; title: string };

export type MorphemeMnemonicsFlashcardSectionTabsGate = Tagged<
  { tabs: readonly MnemonicsTab[] },
  "MorphemeMnemonicsFlashcardSectionTabsGate"
>;

/**
 * Whether a Learn card hosts its mnemonics section tabs. `null` is the designed hidden state: a
 * card with no reading to switch to hosts nothing, leaving the binder tab's own label.
 */
export function getMorphemeMnemonicsFlashcardSectionTabsGate(
  tabs: readonly MnemonicsTab[],
): MorphemeMnemonicsFlashcardSectionTabsGate | null {
  return tabs.some((tab) => tab.pinyin !== undefined)
    ? createGate<MorphemeMnemonicsFlashcardSectionTabsGate>({ tabs })
    : null;
}
